import React from 'react';
import { Button, Image } from '@chakra-ui/react';
import { ff } from '../../../theme';

type Props = {
  label: string;
  icon?: string;
  selected: boolean;
  onClick: () => void;
};

/** Board filter chip — categories are single-select. Selected = lime with an ink outline. */
const Chip: React.FC<Props> = ({ label, icon, selected, onClick }) => (
  <Button
    flexShrink={0}
    h="44px"
    minW={0}
    pl={icon ? '10px' : '14px'}
    pr="14px"
    borderRadius="full"
    fontSize="14px"
    fontWeight={600}
    bg={selected ? ff.lime : 'white'}
    color={selected ? ff.ink : ff.body}
    border={selected ? '1.5px solid' : '1px solid'}
    borderColor={selected ? ff.ink : ff.border}
    _hover={{ bg: selected ? ff.lime : ff.grey }}
    _active={{ bg: selected ? ff.lime : ff.grey }}
    aria-pressed={selected}
    onClick={onClick}
  >
    {icon && <Image src={icon} alt="" w="20px" h="20px" objectFit="contain" flex="none" mr="6px" />}
    {label}
  </Button>
);

export default Chip;
